import { useState, useEffect } from "react";
import Slider from "react-slick";
import styled, { keyframes } from "styled-components";

import ArrowPrev from "../../../src/assets/images/arrow-prev.svg";
import ArrowNext from "../../../src/assets/images/arrow-next.svg";

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;

  const handleClick = () => {
    onClick();
    props.setClickedArrow("prev");
  };

  return (
    <img
      src={ArrowPrev}
      className={className}
      style={{ ...style }}
      onClick={handleClick}
      alt="ArrowPrev"
    />
  );
}

function SampleNextArrow(props) {
  const { className, style, onClick } = props;

  const handleClick = () => {
    onClick();
    props.setClickedArrow("next");
  };

  return (
    <img
      src={ArrowNext}
      className={className}
      style={{ ...style }}
      onClick={handleClick}
      alt="ArrowNext"
    />
  );
}

const carrossel = [
  {
    category: "SÉRIES",
    categoryColor: "#83195C",
    images: [
      {
        title: "Dexter: Pecado Original",
        url: "https://imguol.com.br/p/pp/uol-play/nova-pv/header/series/01.png",
      },
      {
        title: "Duna: A profecia",
        url: "https://imguol.com.br/p/pp/uol-play/nova-pv/header/series/02.png",
      },
      {
        title: "Shark Tank Brasil",
        url: "https://imguol.com.br/p/pp/uol-play/nova-pv/header/series/03.png",
      },
    ],
  },
  {
    category: "FILMES",
    categoryColor: "#3255E2",
    images: [
      {
        title: "Os Fantasmas Ainda se Divertem: Beetlejuice Beetlejuice",
        url: "https://imguol.com.br/p/pp/uol-play/nova-pv/header/filmes/01.png",
      },
      {
        title: "Um Lugar Silencioso: Dia Um",
        url: "https://imguol.com.br/p/pp/uol-play/nova-pv/header/filmes/02.png",
      },
      {
        title: "99 Luas de Paixão",
        url: "https://imguol.com.br/p/pp/uol-play/nova-pv/header/filmes/03.png",
      },
    ],
  },
  {
    category: "ESPORTES",
    categoryColor: "#10B1A8",
    images: [
      {
        title: "Paulistão",
        url: "https://imguol.com.br/p/pp/uol-play/nova-pv/header/esportes/02.png",
      },
      {
        title: "Champions League",
        url: "https://imguol.com.br/p/pp/uol-play/nova-pv/header/esportes/01.png",
      },
      {
        title: "UFC",
        url: "https://imguol.com.br/p/pp/uol-play/nova-pv/header/esportes/03.png",
      },
    ],
  },
  {
    category: "AO VIVO",
    categoryColor: "#FF8000",
    images: [
      {
        title: "Trato feito",
        url: "https://imguol.com.br/p/pp/uol-play/nova-pv/header/aovivo/01.png",
      },
      {
        title: "Big Bang: A Teoria",
        url: "https://imguol.com.br/p/pp/uol-play/nova-pv/header/aovivo/02.png",
      },
      {
        title: "Hawaii Five-0",
        url: "https://imguol.com.br/p/pp/uol-play/nova-pv/header/aovivo/03.png",
      },
    ],
  },
  {
    category: "INFANTIL",
    categoryColor: "#FFAF81",
    images: [
      {
        title: "Todo Mundo Odeia o Chris",
        url: "https://imguol.com.br/p/pp/uol-play/nova-pv/header/infantil/01.png",
      },
      {
        title: "Patrulha Canina",
        url: "https://imguol.com.br/p/pp/uol-play/nova-pv/header/infantil/02.png",
      },
      {
        title: "Bob Esponja",
        url: "https://imguol.com.br/p/pp/uol-play/nova-pv/header/infantil/03.png",
      },
    ],
  },
  {
    category: "ORIGINAIS",
    categoryColor: "#B34EFF",
    images: [
      {
        title: "A Fronteira",
        url: "https://imguol.com.br/p/pp/uol-play/nova-pv/header/originais/01.png",
      },
      {
        title: "Cidade Dominada 2",
        url: "https://imguol.com.br/p/pp/uol-play/nova-pv/header/originais/02.png",
      },
      {
        title: "Copa 90",
        url: "https://imguol.com.br/p/pp/uol-play/nova-pv/header/originais/03.png",
      },
    ],
  },
];

export default function NewHeader() {
  const [sliderData, setSliderData] = useState([]);
  const [activeTab, setActiveTab] = useState(0);
  const [initialized, setInitialized] = useState(false);
  const [count, setCount] = useState(0);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [clickedArrow, setClickedArrow] = useState("");

  const scrollToElementById = () => {
    const offset = 80;
    const element = document.getElementById("planos");

    if (element) {
      const elementPosition =
        element.getBoundingClientRect().top + window.scrollY;

      let position = elementPosition - offset;

      window.scrollTo({
        top: position,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    const intervalo = setTimeout(() => {
      setInitialized(true);
      setClickedArrow("next");
    }, 5000);

    return () => clearTimeout(intervalo);
  }, []);

  function formatarString(s) {
    if (!s?.startsWith('#')) {
        s = '#' + s;
    }
    return s;
}

  const settings = {
    dots: true,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    fade: true,
    nextArrow: <SampleNextArrow setClickedArrow={setClickedArrow} />,
    prevArrow: <SamplePrevArrow setClickedArrow={setClickedArrow} />,
    initialSlide: currentSlide,
    beforeChange: (current, next) => {
      if (
        count === sliderData.length - 1 &&
        current === 2 &&
        clickedArrow === "next"
      ) {
        setActiveTab(0);
        setCount(0);
        return;
      }
      if (count === 0 && current === 0 && clickedArrow === "prev") {
        setActiveTab(sliderData.length - 1);
        setCount(sliderData.length - 1);
        setCurrentSlide(2);
        return;
      }
      if (next === 0 && initialized && clickedArrow === "next") {
        setActiveTab(activeTab + 1);
        setCount(count + 1);
        setCurrentSlide(0);
      }
      if (next === 2 && initialized && clickedArrow === "prev") {
        setActiveTab(activeTab - 1);
        setCount(count - 1);
        setCurrentSlide(2);
      }
    },
    customPaging: (i) => (
      <div className="slick-custom-dots">
        <div className="slick-custom-loading" />
      </div>
    ),
  };

  const TabContentComponent = () => {
    return (
      <Slider {...settings}>
        <div className="poster">
          <img src={sliderData[activeTab]?.images.imgUrl01} />
        </div>
        <div className="poster">
          <img src={sliderData[activeTab]?.images.imgUrl02} />
        </div>
        <div className="poster">
          <img src={sliderData[activeTab]?.images.imgUrl03} />
        </div>
      </Slider>
    );
  };

  useEffect(() => {
    async function getSliderData() {
      try {
        const response = await fetch(
          "https://jsuol.com/p/pp/uol-play/publicador/pv/header.json"
        );
        const data = await response.json();

        setSliderData(data.carrossel);
      } catch (error) {
        console.log(error);
      }
    }

    getSliderData();
  }, []);

  return (
    <Section>
      <Wrapper>
        <LeftContent>
          <h1>
            O streaming do <b>UOL</b> com <br />
            os <b>melhores conteúdos</b>
          </h1>
          <p>
            Planos a partir de <strong>R$ 19,90/mês</strong>
          </p>
          <p>
            Descontos de até <strong>30%</strong>
          </p>
          <a className="cta-button" onClick={scrollToElementById}>
            Conheça os planos
          </a>
          <a
            className="login"
            href="https://painel.play.uol.com.br/selecionar-perfil"
          >
            Já é assinante? Faça seu login
          </a>
        </LeftContent>

        <RightContent initialized={initialized}>
          <TabContainer>
            <div
              className="emphasis"
              style={{
                background: formatarString(sliderData[activeTab]?.categoryColor) || "",
                color: sliderData[activeTab]?.category === "LANCAMENTOS" ? "#000" : "#fff"
              }}
            >
              {sliderData[activeTab]?.category}
            </div>
            <TabContent>
              <TabContentComponent />
            </TabContent>
          </TabContainer>
        </RightContent>

        <MobileContent>
          <h1>
            STREAMING TODO <strong>DIA</strong> <br />
            CINEMA TODO <strong>MÊS</strong>
          </h1>

          <TabContainer>
            <div
              className="emphasis"
              style={{
                background: sliderData[activeTab]?.categoryColor || "",
              }}
            >
              {sliderData[activeTab]?.category}
            </div>
            <TabContent>
              <TabContentComponent />
            </TabContent>
          </TabContainer>

          <p>
            Planos a partir de <strong>R$ 19,90/mês</strong>
          </p>
          <p>
            Descontos de até <strong>30%</strong>
          </p>
          <a className="cta-button" href="#planos-mobile">
            Conheça os planos
          </a>
          <a
            className="login"
            href="https://painel.play.uol.com.br/selecionar-perfil"
          >
            Já é assinante? Faça seu login
          </a>
        </MobileContent>
      </Wrapper>
    </Section>
  );
}

const Section = styled.section`
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 640px;
  background-image: url("https://imguol.com.br/p/pp/uol-play/nova-pv/header/bg-azul.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;

  @media (max-width: 991px) {
    background: rgb(32, 32, 32);
    background: linear-gradient(
      0deg,
      rgba(32, 32, 32, 1) 25%,
      rgba(41, 59, 130, 1) 54%,
      rgba(49, 82, 215, 1) 90%
    );
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    min-height: 560px;
  }
`;

const Wrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin: auto;
  max-width: 1290px;
  padding: 24px 16px;
  margin-top: 140px;
  gap: 48px;
  z-index: 2;

  @media (max-width: 991px) {
    margin-top: 40px;
  }

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 849px;
    height: 620px;
    background-image: url("https://imguol.com.br/p/pp/uol-play/nova-pv/header/bg-header.png");
    background-repeat: no-repeat;
    transform: translate(-38%, -12%);
    z-index: 1;

    @media (max-width: 991px) {
      display: none;
    }
  }
`;

const LeftContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 50%;
  max-width: 548px;
  z-index: 2;

  @media (max-width: 991px) {
    display: none;
  }

  h1 {
    font-size: 3rem;
    color: #ffffff;
    line-height: 58px;
    margin-bottom: 35px;
    text-align: center;
    font-weight: normal;

    strong:nth-of-type(1) {
      color: #fe8001;
    }

    strong:nth-of-type(2) {
      color: #ffce00;
    }
  }

  p {
    font-size: 1.125rem;
    color: #ffffff;
  }

  .cta-button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 250px;
    height: 60px;
    border-radius: 4px;
    background: transparent linear-gradient(180deg, #ffce00 0%, #ff8000 100%) 0%
      0% no-repeat padding-box;
    font-size: 1.25rem;
    font-weight: bold;
    margin-top: 20px;
    transition: all 200ms ease-in-out;

    &:hover {
      color: #000000;
      opacity: 0.8;
    }
  }

  .login {
    font-size: 1rem;
    color: #ffffff;
    margin-top: 25px;
    text-decoration: underline;
  }
`;

const loading = keyframes`
  from {
    width: 0%;
  }

  to {
    width: 100%;
  }
`;

const RightContent = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50%;
  z-index: 1;

  @media (max-width: 991px) {
    display: none;
  }

  &::before {
    content: "";
    position: absolute;
    top: -100px;
    right: -62px;
    width: 797px;
    height: 620px;
    background-image: url("https://imguol.com.br/p/pp/uol-play/nova-pv/header/bg-slider.png");
    background-repeat: no-repeat;
    z-index: -1;

    @media (max-width: 1260px) {
      right: -100px;
    }
    @media (max-width: 1130px) {
      right: -120px;
    }
    @media (max-width: 1070px) {
      right: -140px;
    }
  }

  .slick-slider {
    width: 325px;
    min-height: 500px;
    margin: 0 auto;
  }

  .slider-container {
    position: relative;
    width: fit-content;
    margin: 0 auto;
  }

  .slick-prev {
    width: 50px;
    height: 50px;
    left: -54px;
  }

  .slick-next {
    width: 50px;
    height: 50px;
    right: -54px;
  }

  .slick-dots li {
    width: initial;
    height: initial;

    &:nth-child(4) {
      display: none;
    }
  }

  .slick-active {
    .slick-custom-dots {
      background-color: #ffce00;
      border: 1px solid #ffce00;
      width: 35px !important;
      overflow: hidden;
    }

    .slick-custom-loading {
      display: ${({ initialized}) => initialized ? "block" : "none" };
      height: 10px;
      width: 10px;
      animation: ${loading} 3000ms ease-in infinite;
      background-color: #ff8000;
    }
  }

  .slick-custom-dots {
    background-color: rgba(255, 255, 255, 0.3);
    width: 10px;
    height: 10px;
    border-radius: 99px;
    transition: all 300ms ease;
  }

  .poster {
    width: 325px;
    height: 500px;
    background-color: #202020;
    border-radius: 6px;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 6px;
    }
  }
`;

const MobileContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 auto;

  @media (min-width: 992px) {
    display: none;
  }

  h1 {
    font-size: 1.75rem;
    color: #ffffff;
    font-weight: normal;
    line-height: 32px;
    margin-bottom: 24px;
    text-align: center;

    strong:nth-of-type(1) {
      color: #fe8001;
    }

    strong:nth-of-type(2) {
      color: #ffce00;
    }
  }

  p {
    font-size: 1.125rem;
    color: #ffffff;
  }

  .cta-button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 250px;
    height: 60px;
    border-radius: 4px;
    background: transparent linear-gradient(180deg, #ffce00 0%, #ff8000 100%) 0%
      0% no-repeat padding-box;
    font-size: 1.25rem;
    font-weight: bold;
    margin-top: 20px;

    @media (max-width: 991px) {
      font-size: 1rem;
    }

    &:hover {
      color: #000000;
      opacity: 0.8;
    }
  }

  .login {
    font-size: 1rem;
    color: #ffffff;
    margin-top: 25px;
    text-decoration: underline;
  }

  .slider-container-mobile {
    position: relative;
    width: 325px;
    min-height: 500px;
    margin-bottom: 48px;

    @media (max-width: 480px) {
      width: 60vw;
      min-height: initial;
    }

    &::before {
      content: "";
      position: absolute;
      top: -100px;
      right: -106px;
      width: 533px;
      height: 654.56px;
      background-image: url("https://imguol.com.br/p/pp/uol-play/nova-pv/header/bg-mobile.png");
      background-repeat: no-repeat;
    }
  }

  .emphasis {
    position: absolute;
    top: 1px;
    left: -38px;
    background-color: #83195c;
    padding: 10px 6px;
    padding-left: 32px;
    border-radius: 4px;
    writing-mode: vertical-lr;
    transform: scale(-1, -1);
    color: #ffffff;
    font-size: 1.25rem;
    font-weight: bold;
    transition: all 300ms ease;
  }

  .poster {
    width: 325px;
    height: 500px;

    @media (max-width: 480px) {
      height: auto;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 6px;
    }
  }

  .slick-prev {
    width: 25px;
    height: 25px;
    left: -32px;
  }

  .slick-next {
    width: 25px;
    height: 25px;
    right: -32px;
  }

  .slick-dots li {
    width: initial;
    height: initial;

    &:nth-child(4) {
      display: none;
    }
  }

  .slick-active {
    .slick-custom-dots {
      background-color: #ffce00;
      border: 1px solid #ffce00;
      width: 35px !important;
      overflow: hidden;
    }

    .slick-custom-loading {
      height: 10px;
      width: 10px;
      animation: ${loading} 3000ms ease-in infinite;
      background-color: #ff8000;
    }
  }

  .slick-custom-dots {
    background-color: rgba(255, 255, 255, 0.3);
    width: 10px;
    height: 10px;
    border-radius: 99px;
    transition: all 300ms ease;

    &:nth-of-type(4) {
      display: none;
    }
  }
`;

const TabContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 325px;
  margin-bottom: 32px;

  @media (max-width: 480px) {
    width: 60vw;
  }

  .emphasis {
    position: absolute;
    top: 1px;
    left: -38px;
    background-color: #83195c;
    padding: 10px 6px;
    padding-left: 32px;
    border-radius: 4px;
    writing-mode: vertical-lr;
    transform: scale(-1, -1);
    color: #ffffff;
    font-size: 1.25rem;
    font-weight: bold;
    transition: all 300ms ease;
  }
`;

const TabContent = styled.div``;
